import * as React from 'react';

// Only descendants of this picker can identify their portalled time menus.
export const BookPickerOverlayContext = React.createContext<string | undefined>(undefined);

export function isBookPickerOverlay(target: EventTarget | null, owner: string): boolean {
  return target instanceof Element
    && target.closest('[data-book-picker-owner]')?.getAttribute('data-book-picker-owner') === owner;
}
